import { SxProps } from "@mui/material";

export const sxFormError: SxProps = {
  color: '#CC3D3D',
  fontSize: '12px'
}